import { render, staticRenderFns } from "./templateList.vue?vue&type=template&id=b107d9fe"
import script from "./templateList.vue?vue&type=script&lang=js"
export * from "./templateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports